import type {Timestamp} from 'firebase/firestore'
import {Trans, useTranslation} from 'react-i18next'
import {useMemo} from 'react'

export function TransDate({ts, defaultValue = ''}: { ts: Timestamp | undefined | null, defaultValue?: string }) {
  if (ts == null) {
    return defaultValue
  }

  return <Trans i18nKey="date" values={{timestamp: ts.toDate()}}/>
}

export function TransTime({ts, defaultValue = ''}: { ts: Timestamp | undefined | null, defaultValue?: string }) {
  if (ts == null) {
    return defaultValue
  }

  return <Trans i18nKey="time" values={{timestamp: ts.toDate()}}/>
}

export function TransRelTime({ts, defaultValue = ''}: { ts: Timestamp | undefined | null, defaultValue?: string }) {
  const args = useMemo(
    () => relTimeArgs(ts),
    [ts]
  )

  if (ts == null) {
    return defaultValue
  }


  return <Trans  {...args}/>
}

export function useRelTime(ts: Timestamp | undefined | null, defaultValue = '') {
  const args = useMemo(
    () => relTimeArgs(ts),
    [ts]
  )

  const {t} = useTranslation()

  if (args == null) {
    return defaultValue
  }


  return t(args.i18nKey, args.values)
}

export function relTimeArgs(ts: Timestamp | undefined | null) {
  if (ts == null) {
    return null
  }

  const diffInMillis = ts.toDate().getTime() - Date.now()
  const diffInSeconds = -Math.round(diffInMillis / 1000)
  const diffInMinutes = Math.round(diffInSeconds / 60)
  const diffInHours = Math.round(diffInMinutes / 60)
  const diffInDays = Math.round(diffInHours / 24)

  let key: 'relativeTime.daysPast' | 'relativeTime.hoursPast' | 'relativeTime.minutesPast'
    | 'relativeTime.daysAhead' | 'relativeTime.hoursAhead' | 'relativeTime.minutesAhead' =
    diffInMillis < 0 ? 'relativeTime.daysPast' : 'relativeTime.daysAhead'
  let value = {diff: diffInDays}

  if (Math.abs(diffInHours) < 24) {
    key = diffInMillis < 0 ? 'relativeTime.hoursPast' : 'relativeTime.hoursAhead'
    value = {diff: diffInHours}
  }
  if (Math.abs(diffInMinutes) < 60) {
    key = diffInMillis < 0 ? 'relativeTime.minutesPast' : 'relativeTime.minutesAhead'
    value = {diff: diffInMinutes}
  }
  if (diffInMillis >= 0) {
    value.diff = -value.diff
  }
  return {
    i18nKey: key,
    values: value
  }
}
